// extracted by mini-css-extract-plugin
export var infoItem = "_r0-2";
export var title = "_r0-0";
export var value = "_r0-1";